import type { ReactNode } from 'react'
import { Auth } from '@supabase/auth-ui-react'
import { ThemeSupa } from '@supabase/auth-ui-shared'
import { supabase } from '../../utils/supabase'
import { useAuth } from '../../hooks/useAuth'
import { Navigate, useLocation } from 'react-router-dom'

interface AuthWrapperProps {
  children: ReactNode
  redirectToLogin?: boolean
}

export function AuthWrapper({ children, redirectToLogin = true }: AuthWrapperProps) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    // If redirectToLogin is true, redirect to login page instead of showing auth form
    if (redirectToLogin) {
      // Preserve the intended destination for after login
      return <Navigate to="/login" state={{ from: location }} replace />
    }

    // Otherwise, show the auth form (for the login page itself)
    return (
      <Auth
        supabaseClient={supabase}
        appearance={{
          theme: ThemeSupa,
          variables: {
            default: {
              colors: {
                brand: '#2563eb',
                brandAccent: '#1d4ed8',
              },
            },
          },
        }}
        providers={['google']}
        redirectTo={`${window.location.origin}/auth-redirect`}
        localization={{
          variables: {
            sign_up: {
              password_label: 'Password (minimum 6 characters)',
              password_input_placeholder: 'Enter your password',
            },
          },
        }}
      />
    )
  }

  return <>{children}</>
}